export interface RmaResponse {
  isSuccessful: boolean;
  isNotSuccessful: boolean;
  status: 'Success' | 'Error' | 'NotFound' | 'Gone' | 'Invalid' | 'Unauthorised';
}

export interface RmaErrorResponse extends RmaResponse {
  errorCode: string;
  message: string;
}

// Some endpoints succeed with no response body, while their callers sit on pipelines typed on RmaResponse.
// Those callers map the empty result onto this rather than hand-building an envelope at each call site.
export const RMA_SUCCESS_RESPONSE: RmaResponse = {
  isSuccessful: true,
  isNotSuccessful: false,
  status: 'Success',
};
